// extracted by mini-css-extract-plugin
module.exports = {"burgerMenu":"styles_burgerMenu__1P7P0","line":"styles_line__1ZY8g"};